// Pendências para REGISTRAR uma solicitação de adiantamento (caso 16, QA 25/09).
//
// O `requisitosCliente` da API calcula `pendencias`/`pode_enviar` com os campos
// GRAVADOS em orcamento_adiantamento_detalhes — vazios na primeira solicitação.
// A tela barrava por essa lista e a Sanofi, com Login do Requisitante e Código SAP
// preenchidos, tomava "Preencha o campo..." sem o pedido nem sair.
//
// Regra (igual à da API, ClienteRequisitoService):
//  - documento exigido (PO do evento / proposta): vem pronto do servidor
//    (`pendencias_anexo`) — não se resolve digitando nesta tela;
//  - campos obrigatórios do cliente (`requisitos.campos[x].obrigatorio`): checados
//    com o que está DIGITADO; vazio (ou só espaços) barra, com o mesmo texto da API.

// Campo do requisito -> chave do estado da tela.
const CAMPOS_DIGITADOS = {
    codigo_sap: 'codigoSap',
    login_requisitante: 'loginRequisitante',
};

const PREFIXO_CAMPO = 'Preencha o campo "';

export const mensagemCampoObrigatorio = (regra) =>
    `${PREFIXO_CAMPO}${regra.rotulo}". ${regra.ajuda || ''}`.trim();

const pendenciasAnexo = (requisitos) => {
    if (Array.isArray(requisitos.pendencias_anexo)) return requisitos.pendencias_anexo;
    // API sem o campo novo: o que não é mensagem de campo é do documento.
    return (requisitos.pendencias || []).filter((msg) => !String(msg).startsWith(PREFIXO_CAMPO));
};

/**
 * @param {object|null} requisitos  resposta de GET /orcamento/:id/requisitosCliente
 * @param {{codigoSap?: string, loginRequisitante?: string}} digitado
 * @returns {string[]} mensagens; vazio = pode registrar
 */
export const pendenciasSolicitacaoAdiantamento = (requisitos, digitado = {}) => {
    // Sem requisitos (falha ao carregar) a tela não trava: o servidor barra no envio.
    if (!requisitos) return [];

    const campos = [];
    Object.entries(requisitos.campos || {}).forEach(([nome, regra]) => {
        if (!regra || !regra.obrigatorio) return;
        const chave = CAMPOS_DIGITADOS[nome] || nome;
        const valor = String(digitado[chave] == null ? '' : digitado[chave]).trim();
        if (valor === '') campos.push(mensagemCampoObrigatorio({ rotulo: regra.rotulo || nome, ajuda: regra.ajuda }));
    });

    return [...pendenciasAnexo(requisitos), ...campos];
};

// Aviso da PO do EVENTO na tela de solicitar (Rafael 16/10): uns clientes exigem PO e outros
// não, e a lista ainda não está definida — então a PO NÃO trava o envio (a API devolve
// `anexo.obrigatorio=false` e `anexo.avisar=true`), mas o aviso continua na tela.
// tipo: 'ok' (PO anexada) | 'aviso' (sem PO, não trava) | 'exige' (cliente que voltar a exigir) | null.
export const avisoPoEvento = (requisitos, { poNaoSeAplica = false } = {}) => {
    if (!requisitos || requisitos.anexo_fonte !== 'evento_po') return null;
    const anexo = requisitos.anexo || {};
    if (!anexo.obrigatorio && !anexo.avisar) return null;
    if (requisitos.tem_anexo) return { tipo: 'ok', texto: '' };
    if (anexo.obrigatorio) return { tipo: 'exige', texto: '' };
    if (poNaoSeAplica) return null;
    return {
        tipo: 'aviso',
        texto: 'Este evento ainda não tem PO com arquivo anexado. Alguns clientes exigem a PO para o adiantamento — se for o caso, cadastre na aba P.O. do evento. Não impede o envio.',
    };
};
